<template>
  <div class="container pap-form">
    <div class="layout-section layout-section__image-wrap">
      <h1>You're just a minute away...</h1>
      <img
        src="https://pixapup.com/wp-content/uploads/2020/12/four-dogs-smile-600.jpg"
        alt=""
      />
      <h2>...from helping make more dogs SMILE!</h2>
      <h3>
        With YOUR dog's photo in our books and calendars, we'll ALL help dogs in
        need find their loving forever home!
      </h3>
      <h3>It's FAST, SECURE, and FREE!</h3>
    </div>
    <div class="card">
      <FormTitle title="Sign Up" iconclass="fas fa-user-plus mr-2" />

      <div class="card-body">
        <b-form novalidate @submit.prevent="register">
          <b-form-group
            id="fName-group"
            label="First Name"
            label-for="fName"
            label-class="label-bold"
            :invalid-feedback="form.fName.errorMsg"
            :state="form.fName.valid"
          >
            <b-form-input
              id="fName"
              :maxlength="fieldMaxLength('fName')"
              placeholder="First Name"
              @input="fieldOnInput('fName')"
              v-model="form.fName.value"
              :state="form.fName.valid"
              trim
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="lName-group"
            label="Last Name"
            label-for="lName"
            label-class="label-bold"
            :invalid-feedback="form.lName.errorMsg"
            :state="form.lName.valid"
          >
            <b-form-input
              id="lName"
              :maxlength="fieldMaxLength('lName')"
              placeholder="Last Name"
              @input="fieldOnInput('lName')"
              v-model="form.lName.value"
              :state="form.lName.valid"
              trim
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="email-group"
            label="Email"
            label-for="email"
            label-class="label-bold"
            :invalid-feedback="form.email.errorMsg"
            :state="form.email.valid"
          >
            <p class="form-text text-smaller-1 text-secondary text-center px-3">
              Please use your <strong>best</strong> email address. It's used for
              logging in and for notifying you whenever your dog images are
              selected for and published in our books and calendars.
            </p>
            <b-form-input
              id="email"
              :maxlength="fieldMaxLength('email')"
              placeholder="Email"
              @input="fieldOnInput('email')"
              v-model="form.email.value"
              :state="form.email.valid"
              trim
            ></b-form-input>
          </b-form-group>

          <PasswordField
            id="password"
            label="Password"
            :state="form.password.valid"
            :errorMsg="form.password.errorMsg"
            @password-value-input="setPassword($event, 'password')"
          />

          <PasswordField
            id="confirmPassword"
            label="Confirm Password"
            :state="form.confirmPassword.valid"
            :errorMsg="form.confirmPassword.errorMsg"
            @password-value-input="setPassword($event, 'confirmPassword')"
          />

          <!-- <b-form-group
            id="accept-terms"
            label="Agree To Terms"
            label-class="label-bold"
          > -->
          <div class="p-3">
            <b-form-checkbox
              id="agree-terms-privacy"
              v-model="form.agreeTermsPrivacy.value"
              :value="true"
              :unchecked-value="false"
            >
              <p class="pap-form__text text-smaller-1 mb-1">
                By signing up for a free Pixapup account, I agree to the Pixapup
                <a href="https://pixapup.com/terms-of-service" target="_blank"
                  >Terms of Service</a
                >
                and
                <a href="https://pixapup.com/privacy" target="_blank"
                  >Privacy Policy</a
                >
              </p>
            </b-form-checkbox>
            <!-- </b-form-group> -->

            <b-form-checkbox
              class="mt-2"
              id="agree-cookies"
              v-model="form.agreeCookies.value"
              :value="true"
              :unchecked-value="false"
            >
              <p class="pap-form__text text-smaller-1 mb-1">
                Necessary Cookie: I agree to accept this cookie to enable the
                proper functioning of the Pixapup web app; that without this
                cookie I cannot login, be authenticated, and use the app as it
                is intended.
              </p>
            </b-form-checkbox>

            <b-form-checkbox
              class="mt-2"
              id="agree-email-notify"
              v-model="form.agreeEmailNotify.value"
              :value="true"
              :unchecked-value="false"
            >
              <p class="pap-form__text text-smaller-1 mb-1">
                Yes, I wish to be notified by email whenever one of my dog
                images has been selected for a Pixapup book/calendar and when
                the book/calendar has been published. I know I can unsubscribe
                at any time from within the Pixapup app. Per our
                <a href="https://pixapup.com/privacy" target="_blank"
                  >Privacy Policy</a
                >, we will never share your email address.
              </p>
            </b-form-checkbox>
          </div>

          <FormErrorAlert
            :showAlert="showFormActionError"
            :msg="formErrorMsg"
          />

          <button
            @click="setSubmitted"
            type="submit"
            class="btn btn-block btn-submit pap-form__btn"
            :disabled="!submitEnabled"
          >
            Sign Up
          </button>

          <!-- <p class="form-text text-center px-3">
            By clicking the "Sign Up" button, you are creating a Pixapup account, and you agree to Pixapup's
            <router-link to="/terms-of-service">Terms of Use</router-link>and
            <router-link to="/privacy">Privacy Policy</router-link>.
          </p>-->
          <!-- <b-form-text
            tag="p"
            text-variant="secondary"
            class="px-3 pt-3 pap-form__text"
          >
            By clicking the "Sign Up" button, you are creating a Pixapup account, and you agree to Pixapup's
            <router-link to="/terms-of-service">Terms of Use</router-link> and
            <router-link to="/privacy">Privacy Policy</router-link>.
          </b-form-text> -->
        </b-form>

        <!-- <p class="card-text text-center py-3 pap-form__text text-muted">
          By clicking the "Sign Up" button, you are creating a Pixapup account,
          and you agree to Pixapup's
          <a href="https://pixapup.com/terms-of-service" target="_blank"
            >Terms of Use</a
          >
          and
          <a href="https://pixapup.com/privacy" target="_blank"
            >Privacy Policy</a
          >.
        </p> -->

        <div class="form-footer mt-4">
          <div class="container w-80">
            <div class="hr-label-wrapper">
              <div class="text-center">
                <p class="card-text hr-label bg-white">Already Signed Up?</p>
              </div>
              <div class="hr bg-navbar"></div>
            </div>
            <router-link to="/login" class="btn btn-secondary btn-block"
              >Login Here</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div :class="overlayClass">
      <div class="page-overlay__content-container">
        <b-spinner label="Spinning" variant="secondary"></b-spinner>
        <div class="page-overlay__content-text">
          <p>Thank you!</p>
          <p>Please give us a quick moment to create your account...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormTitle from '@/components/form/FormTitle';
import PasswordField from '@/components/form/FormPasswordField';
import FormErrorAlert from '@/components/form/FormErrorAlert';
import { SignUp } from '@/models/Signup';

import { UploadPreferences } from '@/models/PreferencesUpload'; // set initial upload preferences in 'user' doc (all empty strs except fName and lName)
import { LayoutPreferences } from '@/models/PreferencesLayout'; // set initial layout preferences in 'user' doc

import { mapGetters } from 'vuex';

import stateUtil from '@/helpers/stateUtil';

export default {
  name: 'UserSignUp',
  components: {
    FormTitle,
    PasswordField,
    FormErrorAlert,
  },
  data: function () {
    return {
      pageOverlayHidden: true,

      // Referred-by code, i.e. referral code of user who referred this new user
      refByCode: null,

      // Form data
      form: {
        fName: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        lName: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        email: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        password: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        confirmPassword: {
          value: '',
          valid: null,
          errorMsg: '',
        },
        agreeTermsPrivacy: {
          value: false,
        },
        agreeCookies: {
          value: false,
        },
        agreeEmailNotify: {
          value: false,
        },
      },

      // Text of any overall form error, e.g. validation error, submission result error, etc.
      formErrorMsg: '',

      // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
      formValid: false,

      // Form submission result: Result of form submission (when validated).
      // true: Result of submitted form action was an error; false: Initial state - no error (since form
      // not submitted yet); methods can "reset" this to false to simulate initial state any time after a
      // form submission.
      formError: false,

      // Flag: true: Form submit button was clicked; false: Reset to primitive state, i.e. form not submitted
      formSubmitted: false,
    };
  },

  computed: {
    // ...mapGetters('auth', ['authUser']),
    submitEnabled: function () {
      return this.form.agreeTermsPrivacy.value && this.form.agreeCookies.value;
    },

    showFormActionError: function () {
      return (this.formSubmitted && !this.formValid) || this.formError;
    },
    // page-overlay page-overlay--hide
    overlayClass: function () {
      return {
        'page-overlay': true,
        'page-overlay--hide': this.pageOverlayHidden,
      };
    },
  },

  methods: {
    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },

    setPassword: function (passwordValue, fieldName) {
      this.form[fieldName].value = passwordValue;
      this.fieldOnInput(fieldName);
    },

    fieldMaxLength: function (fieldName) {
      return SignUp.getPropTruncateLength(fieldName) || 50;
    },

    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName) {
      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
      this.formError = false;
      if (this.form[fieldName].valid === false) {
        this.form[fieldName].valid = null; // Set to null to not show validation state feedback on the field, i.e. NO red/green styles
        // console.log('test method called on field', fieldName);
      }
    },

    register_2: async function () {
      //this.pageOverlayHidden = false;
      // var docExistsResult = await pollDocumentExists();
      // setTimeout(() => {
      //   this.pageOverlayHidden = true;
      //   this.$router.push('/');
      // }, 2000);
    },

    showOverlay: function () {
      this.pageOverlayHidden = false;
    },
    hideOverlay: function () {
      this.pageOverlayHidden = true;
    },
    // showObj: function (obj) {
    //   console.log(obj);
    // },
    register: async function () {
      // try {
      //   await this.$fapi.registerUser("gary@ggg.com", "222222");
      // } catch (err) {
      //   console.log("register new user error----", err);
      // }
      // console.log(SignUp, this.$fapi);
      // Form validation --------------
      this.setSubmitted();
      var formData = {};
      Object.keys(this.form).forEach((fieldName) => {
        formData[fieldName] = this.form[fieldName].value;
      });

      // The regex that checks valid email form does NOT like ALL caps, e.g. NAME@gmail.com (but, e.g. Name@gmail.com is ok).
      // [ Wait ... what??? Shouldn't have to do this ... add to to-do.]
      // So, lowercase the email.
      formData.email = formData.email.toLowerCase();

      // console.log('form data obj', formData);

      // var signUp = SignUp.set(formData);
      formData = SignUp.set(formData); // formData now includes props from the Signup schema that are not in the front-end form, i.e. 'enabled' prop

      // console.log('formData', formData);
      // return;

      // console.log('signUp data obj', signUp);
      this.formValid = SignUp.validationPassed();
      if (!this.formValid) {
        this.formErrorMsg =
          'Ooops! Please correct the errors shown in the form above and then click Sign Up again.';
        SignUp.validationErrors().forEach((err) => {
          var propName = SignUp.getErrorProp(err);
          this.form[propName].valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
          this.form[propName].errorMsg = SignUp.getErrorMsg(err);
        });
        return;
      }

      var ts = {
        creTime: Date.now(),
        updTime: Date.now(),
        createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      };

      formData = { ...formData, ...ts }; // formData now ready: Use it to create 'users' doc

      // console.log('form data', formData);
      // return;

      this.showOverlay();

      // // Successful form validation -- attempt new user registration
      try {
        await this.$fapi.registerUser(formData.email, formData.password);

        var {
          fName,
          lName,
          agreeTermsPrivacy,
          agreeCookies,
          agreeEmailNotify,
        } = formData;

        await this.$fapi.setDocument('users', this.$fapi.user.uid, {
          ...UploadPreferences.model,
          fName,
          lName,
          agreeTermsPrivacy,
          agreeCookies,
          agreeEmailNotify,
          createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
          creTime: Date.now(),
          enabled: true,
          ...LayoutPreferences.model,
        });
        // await this.$fapi.createUserDoc(formData);

        await stateUtil.initState(this.$store, this.$fapi);

        // var trackerDocExists = await pollTrackerDocExists(
        //   this.authUser.uid,
        //   this,
        //   2000,
        //   2000,
        //   5
        // );
        // console.log('TRACKER DOC EXISTS?', trackerDocExists);
        // this.$parent.rerenderStatsBar();

        //this.hideOverlay();
        // throw Error('fake error during signup!');
        this.$router.push('/');
      } catch (err) {
        if (this.$fapi.user) {
          await this.$fapi.user.delete();
        }
        this.formError = true;
        this.formErrorMsg = err.message;
      }

      // If no error creating new user, proceed with finalize step
      if (!this.formError) {
        // This returns null if successful; otherwise, returns one of a variety of error msges.
        // Decision: No need to report those errors (useful in debugging, but not for real user)... not 'critical'
        // that user is alerted; therefore, no try/catch block.
        await this.$fapi.firebase.functions().httpsCallable('finalizeNewUser')({
          uid: this.$fapi.user.uid,
          fName,
          email: formData.email,
          refBy: this.refByCode,
        });
      }
      this.hideOverlay();
    },
  },

  created() {
    // If there's a refBy code, it was set in the Home page component; format was checked there.
    this.refByCode = localStorage.getItem('refByCode');

    // console.log(this.$route);
    //var refByCode = localStorage.getItem('refByCode');
    // // If there's a refBy code, check if it *could* be real (i.e. is proper format). If so, store it
    // // in v instance and in localStorage; if malformed, 404 redirect will occur (at router layer).
    // if (this.$route.params[1] && this.$route.params.pathMatch) {
    //   // Check if already a refByCode in local storage; if so, do not override it, i.e. rule
    //   // is 'first person to refer new user sticks'; set instance value as well so that it's used in the signup.
    //   // If there is NOT a refByCode stored, store it.
    //   if (refByCode) {
    //     this.refByCode = refByCode;
    //     console.log('rc', refByCode);
    //   } else {
    //     this.refByCode = `par${this.$route.params.pathMatch}-${this.$route.params[1]}`;
    //     localStorage.setItem('refByCode', this.refByCode);
    //   }
    // } else {
    //   // e.g. if NO route params, i.e. no refByCode path segment...
    //   this.refByCode = refByCode;
    // }

    // if (this.$route.params.referralCode) {
    //   if (this.$route.params.referralCode.length === 10) {
    //     this.refCode = this.$route.params.referralCode;
    //   } else {
    //     this.$router.push('/' + this.$route.params.referralCode);
    //   }
    // }

    // if (this.authUser) {
    //   this.$router.push('/');
    // }
    // if (this.$store.getters['auth/authUser']) {
    //   this.$router.push('/');
    // }
  },
};
</script>

<style>
</style>